export default "__VITE_ASSET__DZ9lF7Hn__"